import { render } from "./TaskDetailModal.vue?vue&type=template&id=09db6958&scoped=true"
import script from "./TaskDetailModal.vue?vue&type=script&lang=js"
export * from "./TaskDetailModal.vue?vue&type=script&lang=js"

import "./TaskDetailModal.vue?vue&type=style&index=0&id=09db6958&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-09db6958"

export default script